import { AssistantGuide } from "../../types";
import { getAssistantWalkthroughUrl } from "../../utils";

export function getAssistantGuideLinks(guides: AssistantGuide[]) {
  return guides.map((guide) => ({
    ...guide,
    href: getAssistantWalkthroughUrl(guide),
  }));
}
